import React, { useState } from 'react';
import './styles/styles.scss';
import Header from './components/Header';
import DiceInputRow from './components/DiceInputRow';
import ResultRow from './components/ResultRow';
import DiceDisplay from './components/DiceDisplay';
import {
  rollDice,
  totalAllRows,
  totalRow,
} from './diceFunctions/rollDice';
import {
  rollWhite,
  rollBlue,
  rollRed,
  rollBlack,
} from './diceFunctions/dice';

const App: React.FC = () => {
  const [numDiceAttribute, setNumDiceAttribute] = useState(0);
  const [numDiceSkill, setNumDiceSkill] = useState(0);
  const [numDiceMinorPenalty, setNumDiceMinorPenalty] = useState(0);
  const [numDiceMajorPenalty, setNumDiceMajorPenalty] = useState(0);

  const [attributeResults, setAttributeResults] = useState([[0, 0]]);
  const [skillResults, setSkillResults] = useState([[0, 0]]);
  const [minorPenaltyResults, setMinorPenaltyResults] = useState([[0, 0]]);
  const [majorPenaltyResults, setMajorPenaltyResults] = useState([[0, 0]]);

  const [rollTotal, setRollTotal] = useState([0, 0]);
  const [showDice, setShowDice] = useState(false);

  const roll = () => {
    const attributeRoll = rollDice(rollWhite, numDiceAttribute);
    setAttributeResults(attributeRoll);
    const skillRoll = rollDice(rollBlue, numDiceSkill);
    setSkillResults(skillRoll);
    const minorPenaltyRoll = rollDice(rollRed, numDiceMinorPenalty);
    setMinorPenaltyResults(minorPenaltyRoll);
    const majorPenaltyRoll = rollDice(rollBlack, numDiceMajorPenalty);
    setMajorPenaltyResults(majorPenaltyRoll);

    const allResults = [
      attributeRoll,
      skillRoll,
      minorPenaltyRoll,
      majorPenaltyRoll,
    ];
    setRollTotal(totalAllRows(allResults));
  };

  const toggleDiceDisplay = () => {
    setShowDice(!showDice);
  };

  return (
    <div className="App">
      <Header />
      <div className="dice-box__container">
        <button
          className="button button__toggle"
          onClick={toggleDiceDisplay}
        >
          Toggle Dice Display
        </button>
        <div className="dice-box">
          <div className="dice-box__tab" />
          <DiceDisplay
            display={showDice}
            whiteResults={attributeResults}
            blueResults={skillResults}
            redResults={minorPenaltyResults}
            blackResults={majorPenaltyResults}
          />
          <DiceInputRow
            className="row--white"
            title="Attribute Dice"
            value={numDiceAttribute}
            setValue={setNumDiceAttribute}
          />
          <DiceInputRow
            className="row--blue"
            title="Skill Dice"
            showAssassinSymbol
            numAssassin={totalRow(skillResults)[1]}
            value={numDiceSkill}
            setValue={setNumDiceSkill}
          />
          <DiceInputRow
            className="row--red"
            title="Minor Penalty Dice"
            showAssassinSymbol
            numAssassin={totalRow(minorPenaltyResults)[1]}
            value={numDiceMinorPenalty}
            setValue={setNumDiceMinorPenalty}
          />
          <DiceInputRow
            className="row--black"
            title="Major Penalty Dice"
            value={numDiceMajorPenalty}
            setValue={setNumDiceMajorPenalty}
          />
          <ResultRow
            value={rollTotal}
            onClick={roll}
          />
        </div>
      </div>
    </div>
  );
}

export default App;
